const AchievementTrophyInfo = [
    {code: "B", medalType: "Bronze", imgSrc: "TrophyBronze.png", medalNbr: 1},
    {code: "S", medalType: "Silver", imgSrc: "TrophySilver.png", medalNbr: 2},
    {code: "G", medalType: "Gold", imgSrc: "TrophyGold.png", medalNbr: 3},
    {code: "J", medalType: "Jewel", imgSrc: "Jewel.png", medalNbr: 4}
];
export default AchievementTrophyInfo;
